import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
const Partner = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      view: false,
      add: true,
      update: false,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      view: false,
      add: true,
      update: false,
    },
    {
      type: "text",
      placeholder: "companyName",
      name: "organization",
      validation: "",
      default: "",
      label: "companyName",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "street",
      name: "streetNumber",
      validation: "",
      default: "",
      label: "street",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "houseNumber",
      name: "houseNumber",
      validation: "",
      default: "",
      label: "houseNumber",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "postalCode",
      name: "postalCode",
      validation: "",
      default: "",
      label: "postalCode",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "city",
      name: "city",
      validation: "",
      default: "",
      label: "city",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    
    {
      type: "select",
      apiType: "API",
      selectApi: "user/countries",
      showItem: "locale",
      placeholder: "country",
      name: "country",
      search: true,
      validation: "",
      default: "",
      label: "country",
      required: false,
      filter: false,
      view: false,
      tag: true,
      add: true,
      update: true,
    },
    // {
    //   type: "textarea",
    //   placeholder: "address",
    //   name: "address",
    //   validation: "",
    //   default: "",
    //   label: "address",
    //   required: true,
    //   view: true,
    //   add: true,
    //   update: true,
    // },
    // {
    //   type: "checkbox",
    //   placeholder: "block-company",
    //   name: "blocked",
    //   validation: "",
    //   showItem: "",
    //   default: "",
    //   label: "block-company",
    //   required: false,
    //   view: false,
    //   tag: true,
    //   add: false,
    //   update: true,
    // },
  ]);
  const [advisor] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      validation: "",
      default: "",
      label: "firstName",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      validation: "",
      default: "",
      label: "lastName",
      required: true,
      view: true,
      add: true,
      update: true,
    },

    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "hidden",
      placeholder: "authorisation",
      name: "authorisation",
      validation: "",
      default: "advisor",
      label: "authorisation",
      showItem: "",
      required: false,
      view: true,
      add: true,
      update: true,
      filter: false,
    },
    {
      type: "select",
      placeholder: "status",
      name: "status",
      validation: "",
      default: "",
      label: "status",
      required: false,
      view: true,
      add: false,
      filter: false,
      update: true,
      apiType: "CSV",
      selectApi: "Active,Inactive",
    },
    {
      type: "invitation",
      placeholder: "invitation",
      tab: "generalInfo",
      name: "invitationSent",
      validation: "",
      showItem: "invitation",
      default: "",
      label: "invitation",
      required: true,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    {
      type: "checkbox",
      placeholder: "acceptLogin",
      tab: "generalInfo",
      name: "acceptLogin",
      validation: "",
      showItem: "",
      default: "",
      label: "acceptLogin",
      required: true,
      view: false,
      tag: true,
      add: false,
      update: false,
    },
    {
      type: "text",
      placeholder: "addedBy",
      name: "addedBy",
      showItem: "fullName",
      collection: "addedBy",
      validation: "",
      default: "",
      label: "addedBy",
      required: false,
      view: true,
      add: false,
      update: false,
    },
  ]);
  const [companyAttribute] = useState([
    {
      type: "text",
      placeholder: "organization",
      name: "organization",
      validation: "",
      default: "",
      label: "organization",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "street",
      name: "streetNumber",
      validation: "",
      default: "",
      label: "street",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "houseNumber",
      name: "houseNumber",
      validation: "",
      default: "",
      label: "houseNumber",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "postalCode",
      name: "postalCode",
      validation: "",
      default: "",
      label: "postalCode",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "city",
      name: "city",
      validation: "",
      default: "",
      label: "city",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "email",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
  ]);
  //to update the page title
  useEffect(() => {
    document.title = `${t("partner")} - Whistleblowing24`;
  }, [t]);

  const [actions] = useState([
    { element: "button", type: "subList", id: "company", itemTitle: "organization", icon: "company", title: "company", attributes: companyAttribute, params: { api: `company/partner`, itemTitle: "organization", shortName: "company", addPrivilege: false, delPrivilege: false, updatePrivilege: false, formMode: "double", datefilter: false, customClass: "medium" } },
    { element: "button", type: "subList", id: "advisor", itemTitle: "firstName", icon: "admin", title: "advisor", attributes: advisor, params: { api: `advisor`, itemTitle: "firstName", shortName: "advisor", addPrivilege: true, delPrivilege: true, updatePrivilege: true, formMode: "double", datefilter: false, customClass: "medium" } }
  ]);

  return (
    <Container className="noshadow">
      <ListTable {...props} actions={actions} api={`partner`} formMode="double" itemTitle={`organization`} shortName={`partners`} addPrivilege={true} delPrivilege={false} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(Partner);
